import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Moment } from 'moment-timezone';
import React from 'react';

interface RequestedDateProps {
    date: Moment;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        label: {
            margin: 0,
            fontSize: 14,
            lineHeight: 1,
            marginBottom: 4
        },
        requestedDate: {
            margin: 0,
            fontSize: 16,
            fontWeight: 600
        },
        requestedDateContainer: {
            padding: '24px 0px'
        }
    })
);

const RequestedDate: React.FC<RequestedDateProps> = props => {
    const classes = useStyles();

    return (
        <div className={classes.requestedDateContainer}>
            <p className={classes.label}>Received on</p>
            <p className={classes.requestedDate}>{props.date?.format('dddd, DD MMM YYYY - hh:mmA')}</p>
        </div>
    );
};

export default RequestedDate;
